import loadable from '@loadable/component';

export const CompensationSurveyPageLoadable = loadable(
  () => import('./CompensationSurveyPage'),
  { resolveComponent: (module) => module.CompensationSurveyPage },
);
